<template>
  <!-- <div class="search-top-wrap"> -->
  <div class="search-container" :class="className">
    <div class="sg-center-padding">
      <div class="clearfix component">
        <router-link to="/"><h1 class="logo"></h1></router-link>
        <div class="search_peiqi">
          <div class="search-box">
            <div
              :class="[
                isshow == false
                  ? 'search-wrap search-wrap-hidden'
                  : 'search-wrap',
              ]"
            >
              <div class="select-box">
                <ul class="ulBox">
                  <li
                    class="searchText"
                    @mouseenter="mouseenterText"
                    @mouseleave="mouseleaveText"
                  >
                    {{ searchChooseList[searchIndex] }}
                  </li>
                  <li
                    :class="[
                      isshow == false ? 'searchListNotShow' : 'searchListShow',
                    ]"
                    v-for="(item, index) in searchChooseListNew"
                    :key="index"
                    @click="getSearchText(item)"
                    @mouseenter="mouseenterText"
                    @mouseleave="mouseleaveText"
                  >
                    {{ item }}
                  </li>
                </ul>
                <!-- <el-dropdown trigger="click">
									<span class="el-dropdown-link">
										配件<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item><div>黄金糕</div></el-dropdown-item>
										<el-dropdown-item>狮子头</el-dropdown-item>
										<el-dropdown-item>螺蛳粉</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown> -->
              </div>
              <!-- <div class="xian"></div> -->
              <el-input
                v-model="searchKey"
                :placeholder="placeholderText"
                @keyup.enter.native="searchEnter"
              >
                <img
                  src="@/assets/questionIcon.svg"
                  alt=""
                  slot="suffix"
                  class="el-input__icon"
                  style="cursor: pointer"
                  @click="iconIsshow = true"
                />
              </el-input>

              <div class="button-wrap" @click="handleSearch">
                <el-button>搜索</el-button>
              </div>
            </div>
            <div class="hot-wrap">
              <span
                @click="getSearchKey(item)"
                class="hot-text"
                v-for="(item, index) in hostList"
                :key="index"
                >{{ item.Name }}</span
              >
            </div>
            <div v-if="iconIsshow">
              <div class="tipBoxMessage">
                <!-- <div class="triangle"></div> -->
                <div class="tipTitle1">配件搜索使用说明</div>
                <div class="tipCourent">
                  若搜索配件："2011款 宝马X3 车门总成"
                </div>
                <div class="tipCourent">可输入："11 X3 车门"</div>
              </div>
            </div>
          </div>

          <div class="image-wrap">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/peiqi_xcx.jpg')"
              :preview-src-list="[require('@/assets/peiqi_xcx.jpg')]"
              fit="contain"
            ></el-image>
          </div>
        </div>

        <!-- <div class="search-container">
        <div class="tab">
          <div
            class="a"
            :class="{ active: searchKey == 'partsName' }"
            @click="searchKey = 'partsName'"
          >
            商品名称
          </div>
          <div
            class="a"
            :class="{ active: searchKey == 'oe' }"
            @click="searchKey = 'oe'"
          >
            零件号
          </div>
          <div
            class="a"
            :class="{ active: searchKey == 'vin' }"
            @click="searchKey = 'vin'"
          >
            <router-link to="/login">VIN车型</router-link>
          </div>
          <div
            class="a"
            :class="{ active: searchKey == 'shop' }"
            @click="handleShopClick"
          >
            店铺
          </div>

         
        </div>
        <div class="search">
          <input
            type="text"
            maxlength="100"
            placeholder="请输入品牌、商品名称、车型"
          />
          <a href="javascript:;" ondragstart="return false" class="btn-search"
            ><i class="el-icon-search"></i
          ></a>
        </div>
      </div> -->
      </div>
    </div>

    <el-dialog
      custom-class="sg-login-dialog"
      :visible.sync="dialogVisible"
      title="请先登录"
      width="400px"
    >
      <login @closeLoginDialog="closeLoginDialog"></login>
    </el-dialog>
  </div>

  <!-- </div> -->
</template>
<script>
import { getTopSearch } from "@/api/partsShopping.js";
import Login from "@/components/Login";
import { mapGetters } from "vuex";
export default {
  props: {
    className: String,
  },
  components: {
    Login,
  },
  watch: {
    searchIndex: {
      //true为进行深度监听,false为不进行深度监听
      handler(newVal) {
        console.log(newVal);
        if (newVal == 0) {
          this.placeholderText = "请输入配件名称";
        } else if (newVal == 1) {
          this.placeholderText = "请输入17位VIN码查询";
        } else if (newVal == 2) {
          this.placeholderText = "请输入OE号";
        }
        let str = this.searchChooseList[newVal];

        let arr = Object.assign([], this.searchChooseList);
        arr.splice(newVal, 1);
        this.searchChooseListNew = arr;
        console.log(arr);
      },
      deep: true,
      immediate: true,
    },
    "$route.path": {
      handler(newVal) {
        console.log(newVal, 7788787887);

        if (newVal == "/parts-list") {
          // console.log(1111)
          return;
        } else {
          this.searchKey = "";
        }
      },
      deep: true,
      immediate: true,
    },
    $route(to, form) {
      console.log(to);
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      // console.log(e.target.className)
      let thisClassName = e.target.className;
      if (
        thisClassName != "el-input__icon" &&
        thisClassName != "tipBoxMessage" &&
        thisClassName != "tipTitle1" &&
        thisClassName != "tipCourent"
      ) {
        this.iconIsshow = false;
      }
    });
  },
  computed: {
    ...mapGetters(["token"]),
  },
  data() {
    return {
      placeholderText: "请输入配件名称",
      iconIsshow: false,
      isshow: false,
      searchIndex: 0,
      searchChooseList: ["名称", "VIN码", "OE号"],
      searchChooseListNew: [],
      searchKey: "",
      dialogVisible: false,
      hostList: [],

      // hostList: [
      //   { text: "ABS泵" },
      //   { text: "车门总成前左" },
      //   { text: "发动机电脑" },
      //   { text: "组合仪表总成" },
      //   { text: "车身控制模块" },
      //   { text: "气囊电脑" },
      //   { text: "刹车真空泵" },
      //   { text: "转向管柱" },
      // ],
    };
  },
  created() {
    getTopSearch().then((res) => {
      console.log(res);
      this.hostList = res.slice(0, 8);
    });
    this.$bus.$off("searchObj");
    this.$bus.$on("searchObj", ({ searchKey, searchType }) => {
      console.log(searchKey, searchType, "search");
      this.getSearchText(searchType);
      this.searchKey = searchKey;
    });
    // 接收首页传递过来的品牌
    // this.$bus.$on("getBrand", (e) => {
    // 	console.log(e)
    // 	this.searchKey = e.Name
    // 	// this.handleSearch()
    // })
  },
  methods: {
    getSearchKey(e) {
      console.log(e, 9999999999);
      this.searchKey = e.Name;
      this.searchIndex = 0;

      this.handleSearch();
      this.$emit("search", {
        searchType: "名称",
        searchKey: this.searchKey,
      });
    },
    searchEnter() {
      // 控制一下，如果用户没输入东西就不去搜索
      if (this.searchKey == "") {
        return;
      } else {
        this.handleSearch();
        // 把input带着，发请求获取有关联的数据并呈现在页面中
        // console.log("带着关键字交给后端搜索", this.input)
      }
    },

    mouseenterText() {
      this.isshow = true;
    },
    mouseleaveText() {
      this.isshow = false;
    },
    getSearchText(e) {
      let index = this.searchChooseList.findIndex((item) => item == e);
      // console.log(index)
      this.searchIndex = index;
      this.isshow = false;
      console.log(this.searchChooseList[this.searchIndex]);
    },
    closeLoginDialog(e) {
      this.dialogVisible = e;
    },
    handleShopClick() {
      if (!this.token) {
        this.dialogVisible = true;
      }
    },
    handleSearch() {
      // console.log(this.searchKey.replace(/\s*/g,""))
      
      if(this.searchChooseList[this.searchIndex]=='OE号'){
        this.searchKey = this.searchKey.replace(/\s*/g,"")
      }
      console.log(this.searchChooseList[this.searchIndex])
      //   if (!this.$store.getters.token) {
      if (!this.token) {
        this.dialogVisible = true;
      } else {
        this.dialogVisible = false;
        if (this.$route.path.indexOf("/parts-list") > -1) {
          this.$bus.$emit("search", {
            searchType: this.searchChooseList[this.searchIndex],
            searchKey: this.searchKey,
          });
          // this.$bus.$emit("search", {searchKey: this.searchKey})
        } else {
          // this.$router.push("/parts-list");
          this.$router.push({
            name: "parts-list",
            params: {
              searchKey: this.searchKey,
              searchType: this.searchChooseList[this.searchIndex],
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// .search-top-wrap{
//   background-color: #fff;
//   overflow: hidden;

// }
.bg-white {
  background-color: white;
}
.component {
  // position: relative;
  margin: 12px auto 8px;
  // z-index: 30;
  display: flex;
  align-items: center;

  .logo {
    position: relative;
    // float: left;
    // width: 290px;
    // height: 56px;
    margin: 4px 0;
    background: url(~@/assets/bottom/logo.png) no-repeat;
    background-size: contain;
    background-position: center center;
    width: 227.3px;
    height: 78px;
  }
  .search_peiqi {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;

    .search-box {
      position: relative;
      margin-left: 136px;
      .tipBoxMessage {
        padding: 0 18px 10px 18px;
        position: absolute;
        top: 57px;
        right: 0;

        width: 300px;
        height: auto;
        background: #ffffff;
        border-radius: 6px;
        z-index: 10;
        .triangle {
          width: 0;
          height: 0;
          border-top: 10px solid skyblue;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
          transform: rotate(180deg);
        }
        .tipTitle1 {
          margin-top: 4px;
          // margin-bottom: 7px;
          font-size: 14px;
          font-weight: 700;
          color: #484747;
        }
        .tipCourent {
          font-size: 14px;
          color: #484747;
        }
      }
      .search-wrap-hidden {
        overflow: hidden;
      }
      .search-wrap {
        width: 675px;
        height: 44px;
        opacity: 1;
        border-radius: 50px;
        background: rgba(255, 255, 255, 1);
        border: 2px solid rgba(29, 32, 137, 1);
        display: flex;
        align-items: center;
        margin: 8px 0 4px 0;
        z-index: 20;

        // flex:1;
        .button-wrap {
          display: flex;
          align-items: center;
        }

        .select-box {
          // background: skyblue;
          width: 90px;
          height: 100%;
          z-index: 10;

          .ulBox {
            position: relative;
            transform-origin: center top;
            z-index: 1;
            height: 100%;

            li {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
              background: #fff;
              cursor: pointer;
              // background: #f2f4f5;
              font-size: 14px;
            }
            .searchText {
              // background: none;
              border-top-left-radius: 50px;
              // border-bottom-left-radius: 50px;
              // background: #f2f4f5;
              z-index: -1;
            }
            .searchText::after {
              content: "";
              // display: inline-block;
              margin-left: 4px;
              width: 6px;
              height: 6px;
              transform: rotateZ(135deg);
              border: 1px solid #666;
              border-left: none;
              border-bottom: none;
              position: relative;
              // top: 0;
              // right: 0;
              // left: 0;
              // bottom: 0;
              // position: absolute;
              top: -2px;
              // right: 10px;
              transition: all 0.3s;
            }
            .searchListNotShow {
              display: none;
            }
            .searchListShow {
              display: block;
              display: flex;
              justify-content: center;
              align-items: center;

              height: 100%;
            }
          }
        }
      }
      .hot-wrap {
        width: 675px;
        overflow: hidden;

        // white-space: nowrap;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 1; /* 这里是超出几行省略 */

        // padding-left: 15px;
        box-sizing: border-box;
        padding: 0 15px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(128, 128, 128, 1);
        .hot-text {
          cursor: pointer;
        }
        .hot-text + .hot-text {
          margin-left: 15px;
        }
      }
    }

    .image-wrap {
      width: 78px;
      height: 78px;
      background: rgba(204, 204, 204, 1);
    }
  }

  // .search-container {
  //   float: left;
  //   margin-left: 90px;
  //   .tab {
  //     > .a {
  //       position: relative;
  //       display: inline-block;
  //       padding: 0 8px;
  //       vertical-align: top;
  //       font-size: 12px;
  //       line-height: 22px;
  //       cursor: pointer;
  //       &.active {
  //         color: #ff4f1a;
  //       }
  //       &:first-child {
  //         margin-left: -8px;
  //       }
  //       &:not(:first-child):before {
  //         position: absolute;
  //         top: 50%;
  //         left: 0;
  //         width: 1px;
  //         height: 8px;
  //         background-color: #ccc;
  //         transform: translate(0, -50%);
  //         content: "";
  //       }
  //     }
  //   }
  //   .search {
  //     position: relative;
  //     font-size: 0;
  //     input[type="text"] {
  //       box-sizing: border-box;
  //       width: 416px;
  //       height: 36px;
  //       padding: 6px 9px;
  //       border: 2px solid #ff4f1a;
  //       // border-color:#ff4f1a ;
  //       border-right: none;
  //       background-color: #fff;
  //       vertical-align: top;
  //       font-size: 14px;
  //       line-height: 20px;
  //       outline: none;
  //       &:focus {
  //         box-sizing: border-box;
  //         width: 416px;
  //         height: 36px;
  //         padding: 6px 9px;
  //         // border: 2px solid #ff4f1a;
  //         border-right: none;
  //         background-color: #fff;
  //         vertical-align: top;
  //         font-size: 14px;
  //         line-height: 20px;

  //         outline: none;
  //       }
  //     }
  //     .btn-search {
  //       // border: none;
  //       //  outline: none;
  //       display: inline-block;
  //       box-sizing: border-box;
  //       width: 64px;
  //       height: 36px;
  //       padding: 0 10px;
  //       color: #fff;
  //       background-color: #ff4f1a;
  //       font-size: 18px;
  //       line-height: 36px;
  //       text-align: center;
  //       transition: background-color 0.2s ease;
  //       &:hover {
  //         background-color: #d84e23;
  //       }
  //     }
  //   }
  // }
}
</style>
<style lang="scss">
.search-wrap {
  .el-input__inner {
    height: 100% !important;
    border: none;
    padding: 0 0;
  }
  .button-wrap {
    .el-button {
      width: 74px;
      height: 44px;
      opacity: 1;
      border-radius: 50px;
      background: linear-gradient(
        90deg,
        rgba(37, 117, 252, 1) 0%,
        rgba(106, 17, 203, 1) 100%
      );
      font-size: 18px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
.sg-login-dialog {
  .el-dialog__header {
    padding: 10px 12px;
    background-color: #f2f4f5;
    position: relative;
    .el-dialog__headerbtn {
      top: 50%;
      transform: translateY(-50%);
    }
    .el-dialog__title {
      color: #666;
      font-size: 16px;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
